module.exports = __webpack_public_path__ + "fonts/Roboto-MediumItalic.56a8235.ttf";